import * as S from './styles';
import * as Form from '@radix-ui/react-form';
import { Either } from '../../utils/propsUtil';
import { View } from '../Basic/View/view';
import { InputMensage } from '../Form/Components/InputMensage';
import { InputTitle } from '../Form/Components/inputTitle';
import { ChangeEvent, useRef, useState } from 'react';
import { useTheme } from '../../utils/context/themeContext';
import { GetSafeValue } from '../../utils/stringUtil';


export interface Props0<T extends HTMLElement = HTMLElement> extends React.HTMLAttributes<T> {
  title?: string | undefined;
  value?: string | number | undefined;
  // eslint-disable-next-line no-unused-vars
  setValue?: ((value: string | number | undefined) => void | React.Dispatch<React.SetStateAction<string | number | undefined>>);
  type?: React.HTMLInputTypeAttribute | undefined;
  require?: boolean
  borderColor?: string | undefined;
  height?: string | undefined;
  borderRadius?: string | undefined;
  placeholder?: string | undefined;
  iconName?: string | undefined;
  limit?: number | undefined
  disabled?: boolean | undefined
}

export interface Props1 {
  label?: string | undefined
  msgError?: string | undefined;
  form: boolean
  name: string
}

export interface Props2 {
}

export const formDefaultProps: Props0 = {
  require: true,
} as Props0

export const normalDefaultProps: Props0 = {
  require: false,
} as Props0

export type InputProps = Props0 & Either<Props1, Props2>;

export function Input (props : InputProps) {
  const inputRef = useRef(null);

  const { theme } = useTheme();
  if (props.form) {
    props = { ...formDefaultProps, ...props }
  } else {
    props = { ...normalDefaultProps, ...props }
  }

  const [error, setError] = useState(false)


  function handleChange(value: string) {
    props.setValue != null && props.setValue(value === "" ? undefined : value);
    setError(false);
  }

  function handleError(value: boolean) {
    return ()=>setError(value)
  }

  function input () {
    function handle(v: ChangeEvent<HTMLInputElement>) {
      handleChange(v.currentTarget.value);
    }

    return (
      props.form ?
        <S.InputWrapper borderRadius={props.borderRadius} borderColor={props.borderColor} >
          <Form.Control asChild>
            <S.Input disabled={props.disabled} ref={inputRef} borderRadius={props.borderRadius} maxLength={props.limit} height={props.height} placeholder={props.placeholder} name={props.name} onChange={handle} value={props.value && GetSafeValue(props.value)} defaultValue={props.defaultValue} className="Input" type={props.type ? props.type : "text"} required={props.require} />
          </Form.Control>
        </S.InputWrapper>
        :
        <S.InputWrapper borderRadius={props.borderRadius} borderColor={props.borderColor}>
          <S.Input disabled={props.disabled} ref={inputRef} borderRadius={props.borderRadius} maxLength={props.limit} height={props.height} placeholder={props.placeholder} onChange={handle} value={props.value && GetSafeValue(props.value)} defaultValue={props.defaultValue} className="Input" type={props.type ? props.type : "text"} required={props.require} />
          {props.iconName ?
            <S.InputIcon icon={props.iconName} height={25} /> :
            <></>
          }
        </S.InputWrapper>
    )
  }

  return (
    <View {...props}>
      {props.form ?
        <Form.Field onInvalid={handleError(true)} className="FormField" name="email">
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', fontWeight: 700, marginBottom: 5 }}>
            <InputTitle form={props.form} label={props.title} />
            <InputMensage form={props.form} label={props.label} type={undefined} />
          </div>
          {error && <InputMensage style={{ fontWeight: undefined, color: theme.colors.warning }} form={props.form} label={props.msgError} type={"valueMissing"} />}
          {input()}
        </Form.Field>
        :
        <>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <InputTitle form={props.form} label={props.title} />
          </div>
          {input()}
        </>
      }
    </View>
  )
}